export const editorConfig = {
    readonly: false,
    placeholder: 'Start typing...',
    height: 400,
    useAceEditor: false,
    sourceEditor: 'area', // Explicitly use native textarea for source view to avoid Ace CDN calls
    beautifyHTML: false, // Prevent loading external beautifier scripts
    zIndex: 100000, // High z-index to appear above modals in fullscreen
    toolbarAdaptive: false,
    uploader: {
        insertImageAsBase64URI: true
    },
    image: {
        openOnDblClick: true,
        editSrc: true,
        useImageEditor: true,
        draggable: true
    },
    popup: {
        img: [
            'image', '|',
            'classSpan', '|', /* Layout Dropdown */
            'left', 'center', 'right', 'justify', '|',
            'valign', '|',
            'link', '|',
            'brush', 'eraser', '|',
            'bin'
        ]
    },
    iframeStyle: `
    @import url('https://fonts.googleapis.com/css2?family=Mukta:wght@200;300;400;500;600;700;800&family=Tiro+Devanagari+Hindi&display=swap');
    
    @font-face {
      font-family: 'Preeti';
      src: url('${window.location.origin}/fonts/Preeti.ttf') format('truetype');
      font-weight: normal;
      font-style: normal;
    }
    @font-face {
      font-family: 'Kantipur';
      src: url('${window.location.origin}/fonts/Kantipur.ttf') format('truetype');
      font-weight: normal;
      font-style: normal;
    }
    @font-face {
      font-family: 'Sagarmatha';
      src: url('${window.location.origin}/fonts/Sagarmatha.ttf') format('truetype');
      font-weight: normal;
      font-style: normal;
    }
    body {
      padding: 20mm;
      font-family: 'Mukta', 'Roboto', sans-serif;
    }
    /* Replicate image classes for Print */
     .img-wrap-left { float: left !important; margin-right: 1.5rem !important; margin-left: 0 !important; margin-bottom: 1rem !important; }
     .img-wrap-right { float: right !important; margin-left: 1.5rem !important; margin-right: 0 !important; margin-bottom: 1rem !important; }
     .img-break-center { float: none !important; display: block !important; margin-left: auto !important; margin-right: auto !important; margin-top: 1rem !important; margin-bottom: 1rem !important; }
  `,
    controls: {
        classSpan: {
            list: {
                'img-wrap-left': 'Wrap Left (Square)',
                'img-wrap-right': 'Wrap Right (Square)',
                'img-break-center': 'Center (Top & Bottom)',
                'img-layer-front': 'Bring to Front',
                'img-layer-back': 'Send to Back'
            }
        },
        font: {
            list: {
                'Roboto, sans-serif': 'Roboto',
                'Open Sans, sans-serif': 'Open Sans',
                'Lato, sans-serif': 'Lato',
                'Montserrat, sans-serif': 'Montserrat',
                'Preeti': 'Preeti',
                'Sagarmatha': 'Sagarmatha',
                'Kantipur': 'Kantipur',
                'Mangal': 'Mangal',
                'Kalimati': 'Kalimati',
                'Mukta, sans-serif': 'Mukta (Devanagari)',
                'Tiro Devanagari Hindi, serif': 'Tiro Devanagari',
                'Arial, Helvetica, sans-serif': 'Arial',
                'Georgia, serif': 'Georgia',
                'Impact, Charcoal, sans-serif': 'Impact',
                'Tahoma, Geneva, sans-serif': 'Tahoma',
                'Times New Roman, Times, serif': 'Times New Roman',
                'Verdana, Geneva, sans-serif': 'Verdana'
            }
        }
    },
    buttons: [
        'source', '|',
        'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol', '|',
        'outdent', 'indent', '|',
        'font', 'fontsize', 'brush', 'paragraph', 'lineHeight', '|',
        'image', 'table', 'link', '|',
        'align', 'undo', 'redo', '|',
        'hr', 'eraser', 'copyformat', '|',
        'symbol', 'fullsize', 'print', 'about'
    ]
};
